import { render, staticRenderFns } from "./UploadResult.vue?vue&type=template&id=6cc36f2e&scoped=true&"
import script from "./UploadResult.vue?vue&type=script&lang=js&"
export * from "./UploadResult.vue?vue&type=script&lang=js&"
import style0 from "./UploadResult.vue?vue&type=style&index=0&id=6cc36f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc36f2e",
  null
  
)

export default component.exports